import {
  Typography,
} from '@mui/material';
import OtpInput from 'react-otp-input';
import styled from 'styled-components';

export const StyledHeading = styled(Typography)`
font-weight: bold;
font-size: 20px;
line-height: 47px;
color: #3D454B;
text-align:center;
`;

export const StyledThemeText = styled(Typography)`
font-weight: 500;
font-size: 12px;
line-height: 15px;
text-align: center;
color: #25CEDE;
`;

export const StyledGrayText = styled(Typography)`
font-weight: 500;
font-size: 12px;
line-height: 15px;
text-align: center;
color: #9E9E9E;
`;

export const StyledImage = styled.img`
max-width:161px;
`;

export const StyledOtp = styled(OtpInput)`
  width: 100%;

  .optInput {
    ${({ theme }) => theme.typography.dsm};
    width: 56.67px !important;
    height: 64px;
    color: #5B8AC5;
    border: 1px solid #475467;
    background: transparent;
    border-radius: 8px;
    outline: none;
    :focus-visible {
      outline: #5B8AC5 auto 1px;
    }
    @media (max-width: 480px) {
      width: 40px !important;
      height: 48px;
      font-size: 20px !important;
    }
  }
  :not(:last-child) {
    margin-right: 16px;
    @media (max-width: 480px) {
      margin-right: 8px;
    }
}
`;

export const BackLoginText = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: 500;
  color: #86A9D4;
  cursor: pointer;
`;
